import { createAction } from 'redux-actions';

export const resetGuestForm = createAction('RESET_GUEST_FORM');

export const setIsUploadingFile = createAction('IS_UPLOADING_FILE');
